export default "/assets/images/winking-face.b9491ead20a13da5.png";